import config from '../../config';

import { createAsyncThunk } from "@reduxjs/toolkit";
// Types
import Reducers from "types/Reducers";
// Actions
import { setResultId } from "store/auth/authSlice";
// Services
import DeviceService from 'services/Device.service';
// Utilities
import fetcher from "utilities/Fetcher";
import StorageService from 'services/Storage.service';
import { RootState } from 'store';

const _url:string = '/player';

// Get player
export const getPlayer = createAsyncThunk(
  `${Reducers.Player}/Get player`,
  async (playerId:string, { rejectWithValue }) => {
    const response:Response = await fetcher(`${_url}/${playerId}`, {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json'
      }
    });
    if ( !response.ok ) return rejectWithValue((await response.json()) as any);
    return response.json();
  }
)

// Get result
export const getResult = createAsyncThunk(
  `${Reducers.Player}/Get result`,
  async (params:any, { rejectWithValue }) => {
    const queryParams = new URLSearchParams();
    if ( Object.keys(params).length ){
      Object.keys(params).forEach((key:string) => {
        if ( params[key] !== '' ) queryParams.append(key, params[key]);
      });
    }
    const response:Response = await fetcher(`${_url}/result?${queryParams}`, {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json'
      }
    });
    if ( !response.ok ) return rejectWithValue((await response.json()) as any);
    return response.json();
  }
)


// Get result answers
export const getResultAnswers = createAsyncThunk(
  `${Reducers.Player}/Get result answers`,
  async (params:any, { rejectWithValue }) => {
    const queryParams = new URLSearchParams();
    if ( Object.keys(params).length ){
      Object.keys(params).forEach((key:string) => {
        if ( params[key] !== '' ) queryParams.append(key, params[key]);
      });
    }
    const response:Response = await fetcher(`${_url}/result/answers?${queryParams}`, {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json'
      }
    });
    if ( !response.ok ) return rejectWithValue((await response.json()) as any);
    return response.json();
  }
)

// Create result
export const createResult = createAsyncThunk(
  `${Reducers.Player}/Create result`,
  async (data:any, { dispatch, rejectWithValue, fulfillWithValue }) => {
    const response:Response = await fetcher(`${_url}/result`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify(data)
    });
    if ( !response.ok && response.status !== 409 ) return rejectWithValue({...(await response.json()) as any, status: response.status});
    const { id } = await response.json();
    dispatch(setResultId(id));
    return fulfillWithValue(id);
  }
);

// Send result
export const sendResult = createAsyncThunk(
  `${Reducers.Player}/Send result`,
  async ({ resultId, data }:{ resultId:any, data:any }, { rejectWithValue, fulfillWithValue, getState }) => {
    const state = getState() as RootState;
    const { additionalAnswers } = state.quiz;

    const nextData = {...data};
    if (additionalAnswers && additionalAnswers.length) nextData['additionalAnswers'] = additionalAnswers;

    const response:Response = await fetcher(`${_url}/result/${resultId}`, {
      method: 'PUT',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify(nextData)
    });
    if ( !response.ok ) return rejectWithValue(({...await response.json(), status: response.status}) as any);
    return fulfillWithValue('Result was sent');
  }
);

// Create analytics data
// export const createAnalyticsData = createAsyncThunk(
//   `${name}/Create analytics data`,
//   async (data:any, { rejectWithValue }) => {
//     const response:Response = await fetcher(`${_url}/analytics`, {
//       method: 'POST',
//       headers: {
//         'Content-Type': 'application/json'
//       },
//       body: JSON.stringify(data)
//     });
//     if ( !response.ok ) return rejectWithValue((await response.json()) as any);
//     return response.json();
//   }
// );

// Update analytics data
export const updateAnalyticsData = createAsyncThunk(
  `${Reducers.Player}/Update analytics data`,
  async (data:any, { rejectWithValue, fulfillWithValue, getState }) => {
    const state = getState() as RootState;
    const { ipLocationInfo } = state.player;
    
    const referrer = StorageService.getReferrer();
    const deviceInfo = DeviceService.fullInfo();

    const nextData: any = {
      ...data,
      deviceInfo,
    }

    if (ipLocationInfo) {
      const { ip, city, region, country, postal, timezone } = ipLocationInfo;
      nextData['ipLocationInfo'] = { ip, city, region, country, postal, timezone };
    }
    if (referrer) nextData['referrer'] = referrer;

    const response:Response = await fetcher(`${_url}/analytics`, {
      method: 'put',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify(nextData)
    });
    if ( !response.ok ) return rejectWithValue({...(await response.json()) as any, status: response.status});
    return fulfillWithValue('Analytics updated')
  }
);

// Increase score
// ToDO: Deprecated
export const increaseScore = createAsyncThunk(
  `${Reducers.Player}/Increase score`,
  async ({ resultId, data }:{ resultId:any, data:any }, { rejectWithValue, fulfillWithValue }) => {
    const response:Response = await fetcher(`${_url}/result/${resultId}/actions/increaseScore`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify(data)
    });
    if ( !response.ok ) return rejectWithValue((await response.json()) as any);
    return fulfillWithValue({ resultId, numberOfPoints: data.numberOfPoints });
  }
);

export const createAnalyticsInteract = createAsyncThunk(
  `${Reducers.Player}/Create analytics interact`,
  async (data:any, { rejectWithValue, fulfillWithValue }) => {
    const response:Response = await fetcher(`${_url}/analytics/interactions`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify(data)
    });
    if ( !response.ok ) return rejectWithValue((await response.json()) as any);
    const result = await response.json();
    return fulfillWithValue({
      resultId: data.result,
      numberOfBonusPoints: result.numberOfBonusPoints || 0,
      newRank: result.newRank || null
    });
  }
);

export const sendAnalyticsTrack = createAsyncThunk(
  `${Reducers.Player}/Send analytics track`,
  async (data:{event: string, quizId: string}, { rejectWithValue, fulfillWithValue }) => {
    const response:Response = await fetcher(`${_url}/analytics/track`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify(data)
    });
    if ( !response.ok ) return rejectWithValue((await response.json()) as any);
    return fulfillWithValue('Analytics track sent')
  }
);

// get IP info
export const getIpInfo = createAsyncThunk(
  `${Reducers.Player}/Get IP info`,
  async (_, { fulfillWithValue }) => {
    // try catch is required for a possible ad blocker error
    try {
      const locationResponse:Response = await fetch(config.ipInfoUrl, { referrerPolicy: 'no-referrer' })
      const location:any = await locationResponse.json();
      return fulfillWithValue(location)
    } catch { }
  }
);
